package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.series.SimplePersistentSeriesDto
import com.exura.features.plandefinition.domain.model.series.SimplePersistentSeries
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between SimplePersistentSeries domain model and DTO.
 * Implements BaseSeriesMappers for Firebase storage compatibility.
 */
class SimplePersistentSeriesMappers : BaseSeriesMappers<SimplePersistentSeries, SimplePersistentSeriesDto> {
    override fun toDto(model: SimplePersistentSeries): SimplePersistentSeriesDto = SimplePersistentSeriesDto(
        name = model.title,
        description = model.description,
        seriesType = model.seriesSpawnType,
        durationInDays = model.durationInDays(),
        relativeDay = model.relativeDay,
        startHourOfDay = model.startHourOfDay,
        icon = model.icon,
        durationDays = model.durationDays,
        durationInMinutes = model.durationInMinutes,
        imageUrl = model.imageUrl,
    )

    override fun toDomain(dto: SimplePersistentSeriesDto, collection: CollectionReference?, id: String?): SimplePersistentSeries = SimplePersistentSeries(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        title = dto.name,
        description = dto.description,
        relativeDay = dto.relativeDay,
        elements = emptyList(), // Elements would be loaded separately
        durationDays = dto.durationDays,
        durationInMinutes = dto.durationInMinutes,
        startHourOfDay = dto.startHourOfDay,
        icon = dto.icon,
        imageUrl = dto.imageUrl,
    )
}
